import { MessageModel } from '@/models/message.model'
import { api } from '@/services/api'

export async function save(message: MessageModel) {
  await api.post(`/messages/save`, { message })
}

export async function saveMany(messages: MessageModel[]) {
  await api.post(`/messages/save-many`, { messages })
}
